/** The result actions `sp-finder` exposes to its result view. Each runs on the finder's request owner. */
export const RESULT_COMMANDS = Object.freeze([
  "showPage",
  "showPerPage",
  "showDate",
  "selectView",
  "showOnMap",
  "addFilters",
  "showMoreSlots",
  "playVideo",
]);
